import React from "react";
import "./ExploreShlokMonumentBlock.css";

export const ExploreShlokMonumentBlock = () => {
  return (
    <div className="exploreSection">
      <div className="exploreSection__container">
        {/* Card 1: Monuments */}
        <div className="exploreCard exploreCard--monuments">
          <div className="exploreCard__content">
            <h2 className="exploreCard__title">
              Explore
              <br />
              Monuments
            </h2>
            <p className="exploreCard__description">
              Discover India’s magnificent monuments, timeless forts, and
              architectural wonders that tell stories of valor, wisdom and
              heritage.
            </p>
          </div>
          {/* Badge wrapper placeholder */}
          <div className="exploreCard__badgeArea">
            <span className="exploreCard__badge">Coming Soon!</span>
          </div>
        </div>

        {/* Card 2: Sholaks */}
        <div className="exploreCard exploreCard--sholaks">
          <div className="exploreCard__content">
            <h2 className="exploreCard__title">
              Explore
              <br />
              Shlokas
            </h2>
            <p className="exploreCard__description">
              Discover the wisdom of ancient Sholaks, timeless teachings that
              inspire values, clarity and purpose in life.
            </p>
          </div>
          {/* Badge wrapper placeholder */}
          <div className="exploreCard__badgeArea">
            <span className="exploreCard__badge">Coming Soon!</span>
          </div>
        </div>
      </div>
    </div>
  );
};
